<template>
  <div class="h-100">
    <component
      v-if="cardConfig.type != null"
      :is="cardConfig.type"
      :config="cardConfig"
      :layoutData="layoutData"
      :data="data"
      class="h-100"
    ></component>
  </div>
</template>

<script>
import test_card from "@/views/components/dashboard/GlobalDashboardCard_Test";
import multi_level_line from "@/views/components/dashboard/GlobalDashboardCard_Multi_LeveL_Line";
import donut_chart from "@/views/components/dashboard/GlobalDashboardDoughnutChart.vue";
import horizentalbar_chart from "@/views/components/dashboard/GlobalDashboardBarChart.vue";
import dataTable_chart from "@/views/components/dashboard/GlobalDashboardTableChart.vue";
import simple_chart from "@/views/components/dashboard/GlobalDashboardCardChart";
import horizentalbar2_chart from "@/views/components/dashboard/GlobalDashboardColumnChart";

export default {
  components: {
    test_card,
    multi_level_line,
    donut_chart,
    horizentalbar_chart,
    dataTable_chart,
    simple_chart,
    horizentalbar2_chart,
  },
  props: {
    cardConfig: { type: Object, default: {} },
    layoutData: { type: Object, default: {} },
    data: { default: {} },
  },
  setup(props) {
    return {
      props,
    };
  },
};
</script>


<style scoped>
.center-content {
  justify-content: center;
}

.max-row-height {
  height: 100%;
}

.max-height-panel {
  height: calc(100% - 2rem);
}
.max-height-card {
  height: 100%;
  border-radius: 1.428rem;
}
</style>
